<!--
 * @Date: 2022-04-07 10:23:22
 * @Author: 陶子
 * @LastEditTime: 2022-04-07 18:15:40
 * @FilePath: \jk_one-stop_cloud_mobile_v1.0\src\views\mine\feedback.vue
 * @pageName: 这是--(意见反馈)--页面
-->
<template>
  <div class="wrap">
    <Navbar :appTitle="title" />
    <div class="contianBox">
      <div class="logoBox">
        <div class="logoPic">
          <img src="@/assets/JKlogo.png" alt="" />
        </div>
        <div class="logoTitle">
          <p>来睿科技</p>
        </div>
      </div>
      <div class="messageBox">
        <div class="messageContent">
          <p>客服热线：400-718-9668</p>
          <p>服务时间：周一至周五09:00~18:00</p>
          <p>当前版本：v 2.0.0</p>
        </div>
      </div>
      <div class="bottomBox">
        <p>安徽来睿科技有限公司提供技术支持</p>
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from "@/components/navBar/navBar_right";
export default {
  data() {
    return {
      title: this.$route.meta.title,
    };
  },
  components: {
    Navbar,
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {

  },
};
</script>
<style lang='scss' scoped>
.contianBox {
  display: flex;
  flex-direction: column;
  background: #fff;
  text-align: center;
  box-sizing: border-box;
  border-top: 1px solid #f2f2f6;
  height: calc(100vh - 92px);
  .logoBox {
    padding: 200px 0 0;

    .logoPic {
      img {
        height: 100px;
      }
    }
    .logoTitle {
      p {
        font-size: 60px;
        font-weight: 500;
      }
    }
  }
  .messageBox {
    margin: 100px 20px 300px;
    padding: 60px 0 30px;
    border: 1px solid #f2f2f6;
    border-radius: 24px;
    .messageContent {
      width: 55%;
      text-align: left;
      position: relative;
      left: 25%;
    }
  }
  .bottomBox {
    flex: 1;
  }
}
</style>
